import { ChangeDetectionStrategy, Component, WritableSignal } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { TranslocoDirective } from '@jsverse/transloco';
import { User } from '@core/interfaces/user.interface';
import { Country } from '@core/interfaces/country.interface';
import { AuthService } from '@core/services/auth.service';
import { CountryService } from '@core/services/country.service';
import { AvatarComponent } from '@core/components/avatar/avatar.component';
import { FooterComponent } from '@core/components/footer/footer.component';
import { CountryModalComponent } from '@core/components/modals/country/country-modal.component';
import { LoginModalComponent } from '@core/components/modals/auth/login/auth-login-modal.component';
import { FormSelectComponent } from '../forms/select/form-select.component';

@Component({
  standalone: true,
  selector: 'ups-shell',
  styleUrl: './shell.component.scss',
  templateUrl: './shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { 
    class: 'd-flex flex-column h-100' 
  },
  imports: [
    RouterLink,
    RouterLinkActive,
    IonicModule,
    TranslocoDirective,
    AvatarComponent,
    FooterComponent,
    FormSelectComponent
  ]
})
export class ShellComponent {

  public readonly user: WritableSignal<User> = this.authService.user;
  public readonly activeLang: WritableSignal<string> = this.countryService.activeLanguage;
  public readonly activeCountry: WritableSignal<Country> = this.countryService.activeCountry;
  public readonly navMenu: { label: string, route: string, icon: string }[] = [
    { label: 'Article', route: '/', icon: 'newspaper-outline' },
    { label: 'Watch', route: 'watch', icon: 'tv-outline' },
    { label: 'Deals', route: 'deals', icon: 'cart-outline' }
  ];
  public isSearching: boolean = false;
  
  constructor(
    protected readonly navCtrl: NavController,
    protected readonly authService: AuthService,
    protected readonly modalCtrl: ModalController,
    protected readonly countryService: CountryService
  ) { }

  public changeLang(l: any): void{ 
    if (l !== this.activeLang()) this.countryService.setActiveLanguage(l);
  }

  public logout(): void{ 
    this.authService.logout();
    this.navCtrl.navigateRoot('/'); 
  }

  public search(ev: any, m: any): void{ 
    if (ev.value) {
      this.navCtrl.navigateRoot('/search', { queryParams: { s: ev.value, m }}); 
      ev.value = ''; 
    }
    ev.blur();
  }

  public async openLogin(): Promise<void>{ 
    (await this.modalCtrl.create({ cssClass: 'folay-container full100-flex-col', component: LoginModalComponent })).present(); 
  }

  public async openCountryModal(): Promise<void>{ 
    (await this.modalCtrl.create({ cssClass: 'country-modal', component: CountryModalComponent })).present(); 
  }
}
